import Logo from 'pages/signup/components/Logo';
import { HeaderWrapper } from './style';

export const Header = () => {
    return (
        <HeaderWrapper>
            <Logo width={140} />
        </HeaderWrapper>
    );
};
